import { useState } from 'react';
import { evidenceCards, evidenceTags } from '@/mocks/gossip';
import SectionHead from './SectionHead';

export default function EvidenceSection() {
  const [active, setActive] = useState('全部');
  const list = active === '全部' ? evidenceCards : evidenceCards.filter((c) => c.tag === active);

  return (
    <section id="shichui" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHead
          en="Verified Files"
          title="实锤速递 · 新截图 / 新录音 / 新视频"
          desc="每一份材料都标注了核验状态，红色底为已多方交叉核验的实锤，绿色底为仍需补充的线索。"
        />

        <div className="mb-7 inline-flex flex-wrap items-center gap-2 rounded-full bg-secondary-100 p-1">
          {evidenceTags.map((t) => (
            <button
              key={t}
              type="button"
              onClick={() => setActive(t)}
              className={`rounded-full px-4 py-1.5 text-sm font-medium whitespace-nowrap transition-colors ${
                active === t
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-700 hover:bg-background-50'
              }`}
            >
              {t}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((card) => (
            <article
              key={card.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <a href="#zhuizong" className="relative block overflow-hidden">
                <div className="aspect-[8/5] overflow-hidden">
                  <img
                    src={card.image}
                    alt={`${card.category}证据素材展示图`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <span
                  className={`absolute top-3 left-3 inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-semibold whitespace-nowrap ${
                    card.tag === '实锤'
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-accent-500 text-background-50'
                  }`}
                >
                  {card.tag === '实锤' ? <i className="ri-lock-2-fill" /> : <i className="ri-search-eye-line" />}
                  {card.tag}
                </span>
                <span className="absolute right-3 bottom-3 rounded-full bg-background-950/60 px-2.5 py-1 text-xs font-medium whitespace-nowrap text-background-50 backdrop-blur">
                  {card.badge}
                </span>
              </a>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1 rounded bg-secondary-100 px-2 py-0.5 font-medium text-secondary-900">
                    {card.category}
                  </span>
                  <span>·</span>
                  <span>{card.date}</span>
                </div>
                <a href="#zhuizong">
                  <h3 className="font-heading mt-2.5 line-clamp-2 text-base leading-snug font-bold text-foreground-950 transition-colors hover:text-primary-700">
                    {card.title}
                  </h3>
                </a>
                <p className="mt-2 line-clamp-3 flex-1 text-sm leading-relaxed text-foreground-600">
                  {card.summary}
                </p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                  <span className="text-xs whitespace-nowrap text-foreground-500">
                    {card.author}
                  </span>
                  <span className="inline-flex items-center gap-3 text-xs whitespace-nowrap text-foreground-500">
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-eye-line" />
                      {card.views}
                    </span>
                    <span className="inline-flex items-center gap-1 text-primary-500">
                      <i className="ri-fire-fill" />
                      {card.hot}
                    </span>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}